export default {
  methods: {
    controlLoadingSpinner (show) {
      //console.log("\n\n*****  Chiamato loader..."+ show )
      this.$root.$emit('isLoading', {isLoading: show})
    }
  }
}
